<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      ตารางนัดหมาย
    </h1>
  </div>
  <div *ngIf="role === 'admin'" class="row d-flex justify-content-between mb-2">
    <div>
      <label>
        Export ตารางนัดหมายเดือน
      </label>
      <input [(ngModel)]="monthSelected" class="form-control ml-3" style="width: 200px; display: inline-block;"
        type="month" min="2021-01" [max]="maxDate">
    </div>
    <!-- <button *ngIf="monthSelected" class="col-form-label ml-3" mat-mini-fab color="primary">
      <img src="../../../../assets/direct-download-white.png" style="width: 20px;">
    </button>
    <button *ngIf="!monthSelected" class="col-form-label ml-3" disabled mat-mini-fab>
      <img src="../../../../assets/direct-download-white.png" style="width: 20px;">
    </button> -->
    <lifedi-btn *ngIf="monthSelected" (click)="exportExcelByMonth()" lable="Export ตาราง"
      customStyle="background-color: #060e9f; color: #fff; margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
    <lifedi-btn *ngIf="!monthSelected" lable="Export ตาราง" disabled="true"
      customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
  </div>
  <div class="row d-flex justify-content-between">
    <h4 *ngIf="(role === 'psychologist' || role === 'teacher') && profile" for="name">
      <span *ngIf="role === 'psychologist'">นักจิตวิทยา : {{ profile.USERNAME }}</span>
      <span *ngIf="role === 'teacher'">อาจารย์ : {{ profile.USERNAME }}</span>
    </h4>

    <select *ngIf="role === 'admin'" class="custom-select form-control" id="name" style="width: 300px;"
      (change)="consultSelected($event)">
      <option value="" selected disabled hidden>เลือกผู้ให้คำปรึกษา</option>
      <option *ngFor="let consult of allConsult" [value]="consult.USER_ID">อ. {{ consult.USERNAME }}</option>
    </select>

    <lifedi-btn *ngIf="userId" lable="เพิ่ม consult"
      customStyle="background-color: #005C3D; color: #FFF; margin-top: 0px; padding: 0 25px;" (click)="storeId(userId)">
    </lifedi-btn>
    <lifedi-btn *ngIf="!userId" lable="เพิ่ม consult" disabled="true" customStyle="margin-top: 0px; padding: 0 25px;">
    </lifedi-btn>
  </div>

  <div *ngIf="userId" class="row text-center justify-content-center mt-4">
    <div class="btn btn-primary mr-3" mwlCalendarPreviousView view="month" [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"> &#60; </div>
    <!-- <div class="h4" style="width: 220px; margin: 4px;">{{ getMonth(viewDate) }}</div> -->
    <div class="h4" style="width: 220px; margin: 4px;">
      {{ viewDate | calendarDate:('month' + 'ViewTitle' ):'en' }}
    </div>
    <div class="btn btn-primary ml-3" mwlCalendarNextView view="month" [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"> &#62; </div>
  </div> <br />

  <div *ngIf="userId" style="margin: 0 -15px;">
    <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
      (eventClicked)="handleEvent($event.event)">
    </mwl-calendar-month-view>
  </div>
  <br><br>
</div>
